var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Dashboard",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3380",
    "data-name": "Rectangle 3380",
    width: 20,
    height: 20,
    fill: "#333"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3562",
    "data-name": "Group 3562",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1968",
    "data-name": "Path 1968",
    d: "M171.6,10.43a.238.238,0,0,0-.028.051,1.463,1.463,0,0,1-1.543,1.189q-2.822,0-5.643,0c-.15,0-.3,0-.449,0a1.466,1.466,0,0,1-1.505-1.508c-.007-.651,0-1.3,0-1.953q0-3.329,0-6.659a1.446,1.446,0,0,1,.93-1.442,1.6,1.6,0,0,1,.551-.1q3.1-.011,6.21,0a1.45,1.45,0,0,1,1.439,1.122c.011.043.027.085.04.127Zm-1.25-4.6q0-2.128,0-4.256c0-.275-.053-.327-.333-.327h-6.012c-.263,0-.324.059-.324.318q0,4.265,0,8.531c0,.257.064.32.326.32h6.013c.274,0,.331-.058.331-.331q0-2.128,0-4.256",
    transform: "translate(-151.602 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1969",
    "data-name": "Path 1969",
    d: "M1.251,136.606a4.451,4.451,0,0,1-.741-.368A1.269,1.269,0,0,1,0,135.184Q0,130.771,0,126.358a1.449,1.449,0,0,1,1.508-1.42c.989-.006,1.979,0,2.968,0h3.1a1.474,1.474,0,0,1,1.584,1.585q0,4.149,0,8.3a1.533,1.533,0,0,1-1.24,1.785Zm0-5.84q0,2.118,0,4.236c0,.308.044.354.345.354H7.569c.3,0,.351-.051.351-.351q0-4.236,0-8.472c0-.288-.057-.347-.339-.347H1.588c-.285,0-.338.054-.338.344q0,2.118,0,4.236",
    transform: "translate(0 -116.606)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1970",
    "data-name": "Path 1970",
    d: "M163.611,206.6a3.733,3.733,0,0,1-.417-.154,1.4,1.4,0,0,1-.818-1.3c-.013-1.256-.017-2.512,0-3.768a1.441,1.441,0,0,1,1.5-1.446c1.5-.007,2.994,0,4.491,0,.534,0,1.067,0,1.6,0a1.463,1.463,0,0,1,1.542,1.189.234.234,0,0,0,.028.051v4.18a4.893,4.893,0,0,1-.312.678,1.462,1.462,0,0,1-.937.572Zm3.344-1.25h3.006c.278,0,.329-.051.329-.33q0-1.756,0-3.513c0-.27-.058-.326-.336-.326h-5.992c-.285,0-.342.058-.342.343q0,1.747,0,3.493c0,.276.057.333.329.333h3.006",
    transform: "translate(-151.541 -186.604)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1971",
    "data-name": "Path 1971",
    d: "M4.6.011H7.624A1.464,1.464,0,0,1,9.178,1.565q0,1.776,0,3.552A1.471,1.471,0,0,1,7.61,6.68q-3.016,0-6.031,0A1.469,1.469,0,0,1,.009,5.1q0-1.766,0-3.533A1.462,1.462,0,0,1,1.574.011H4.6m0,1.25H1.589c-.279,0-.33.05-.33.329q0,1.757,0,3.513c0,.27.058.328.334.328H7.585c.285,0,.343-.058.343-.342q0-1.747,0-3.493c0-.276-.057-.334-.328-.334H4.594",
    transform: "translate(-0.008 -0.01)",
    fill: "#333"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.1915a4252407d9dd1af87c21de4b260e.svg";
export { ForwardRef as ReactComponent };